/**
 * De rekenkern achter `useVolgSticky`: hoeveel de inhoudsopgave nog "onthuld" moet
 * worden bovenop zijn sticky-pin, en hoeveel daar hoogte-technisch nog voor over is.
 *
 * Losgetrokken van de DOM-laag (`useVolgSticky.ts`) zodat de rekenregel zelf, zonder
 * scroll- of ResizeObserver-gedoe, in Node te toetsen is (zelfde opzet als
 * `nummering.ts`/`nummering.node.test.ts`). Zie `useVolgSticky.ts` voor het waarom
 * van het mechanisme zelf: dat is de CitatenPOC's "leesrichting-volgende sticky"
 * (`src/editor/useFollowSticky.ts`), hier overgenomen omdat eFormulieren/CLAUDE.md de
 * CitatenPOC voor het gedrag van controls de maatstaf noemt, niet vertrekpunt.
 */

/**
 * Hoeveel van het element buiten beeld blijft, ook als het bovenaan vastzit met
 * `topGap` lucht erboven en `bottomGap` eronder. Nul zodra het element (met zijn
 * gaten meegerekend) gewoon in de viewport past: dan is er niets te onthullen en
 * werkt een klassieke top-pin.
 */
export function computeOverflow(
  heightElement: number,
  heightViewport: number,
  topGap: number,
  bottomGap: number,
): number {
  return Math.max(0, heightElement - (heightViewport - topGap - bottomGap))
}

/**
 * De nieuwe onthul-offset na één scrollstap.
 *
 * Vóór de pin-drempel (`natuurlijkeTop > topGap`, het element staat nog in de
 * gewone flow bovenaan de pagina) blijft de offset op nul, zodat de overgang van
 * flow naar pin naadloos op `top = topGap` gebeurt en er geen sprong ontstaat.
 * Ná de drempel accumuleert de offset mee met de scrollrichting (`delta`), geklemd
 * op `[0, overloop]` zodat hij nooit verder onthult dan er randruimte is. Bij een
 * richtingsomkeer zit de offset al op een uiterste en beweegt meteen de andere kant
 * op: geen dode zone waarin eerst wordt "ingehaald".
 */
export function computeRevealOffset(
  previousOffset: number,
  delta: number,
  overflow: number,
  naturalTop: number,
  topGap: number,
): number {
  if (naturalTop > topGap) return 0
  return Math.min(overflow, Math.max(0, previousOffset + delta))
}
